(function () {
  window.__blairDeck = 'init';
  var doc = document.documentElement;

  // Each inner array = one swipe screen (its section ids grouped together), in page order.
  var GROUPS = [
    ['blair_hero_main'],
    // Collection marquee + "Blair Tel Aviv" rich-text + the product row share ONE screen (founder:
    // "they should be on the same page" — splitting them left two half-empty screens). The rich-text
    // heading is compacted (CSS below) so all three fit WITHOUT a fit() zoom, which keeps the
    // full-bleed collection marquee spanning the full width.
    ['collection_list_PifXta', 'rich_text_DLtaCR', 'featured_collection_cF9RAK'],
    // Moissanite pair (blairtlv4 2026-07-28). A slideshow + featured collection added to
    // the homepage is INVISIBLE to the deck until it is listed here, and an unlisted pair
    // never gets wrapped in .blair-panel, so it keeps the full 1616px page width instead of
    // the 60vw panel width the other pairs get, does not pair, and does not fit a screen.
    // That was the whole difference the founder kept seeing. Groups are in page order.
    ['slideshow_moissanite', 'featured_collection_moissanite'],
    ['slideshow_9mgNDf', 'featured_collection_GBpCHd'],
    ['slideshow_EWtEFQ', 'featured_collection'],
    ['slideshow_VPbjxJ', 'featured_collection_WEwi64'],
    ['featured_collection_gpRk9c'],
    ['17459611929b25bfa3'],
    ['multicolumn_D8a6mF'],
    ['blair_giftcard', 'blair_band_ringbox']
  ];

  // ids are "shopify-section-template--<hash>__<key>"; match the "__<key>" suffix.
  function sectionEl(id) {
    return document.querySelector('#MainContent [id$="__' + id + '"]') || document.getElementById('shopify-section-' + id);
  }
  function panelFrom(els, cls) {
    els = els.filter(Boolean);
    if (!els.length) return null;
    var panel = document.createElement('div');
    panel.className = cls;
    var inner = document.createElement('div');
    inner.className = 'blair-panel__inner';
    els[0].parentNode.insertBefore(panel, els[0]);
    els.forEach(function (el) { inner.appendChild(el); });
    panel.appendChild(inner);
    return panel;
  }

  var panels = [];
  function build() {
    if (doc.querySelector('.blair-panel')) { return true; }      // already built (idempotent)
    var main = document.getElementById('MainContent');
    if (!main || !sectionEl('blair_hero_main')) return false;     // sections not in the DOM yet

    var built = [];
    GROUPS.forEach(function (ids) {
      var p = panelFrom(ids.map(sectionEl), 'blair-panel');
      if (p) built.push(p);
    });
    // Footer group = TWO separate swipes (founder: "those are two different sections each on
    // their own page swipe"): the footer section (brand + links + social + country) on one
    // screen, and the trailing sections (newsletter signup + back-to-top + spacer) on the next.
    var footerAnchor = document.querySelector('.footer, .section-footer');
    var footerSec = footerAnchor && footerAnchor.closest ? footerAnchor.closest('.shopify-section') : null;
    if (footerSec) {
      // anything in the footer group BEFORE the footer section (rare) rides with the footer
      var lead = [footerSec], sib = footerSec.previousElementSibling;
      while (sib && sib.classList && sib.classList.contains('shopify-section')) { lead.unshift(sib); sib = sib.previousElementSibling; }
      // trailing footer-group sections (newsletter, spacer) become a SECOND panel
      var trailing = [];
      sib = footerSec.nextElementSibling;
      while (sib && sib.classList && sib.classList.contains('shopify-section')) { trailing.push(sib); sib = sib.nextElementSibling; }
      var fp = panelFrom(lead, 'blair-panel blair-panel--footer');
      if (fp) built.push(fp);
      if (trailing.length) {
        var np = panelFrom(trailing, 'blair-panel blair-panel--footer');
        if (np) built.push(np);
      }
    }
    if (!built.length) return false;

    panels = built;
    doc.classList.add('blair-deck-on');
    window.__blairDeck = 'built:' + panels.length;

    // Re-run the shrink-to-fit AFTER images (esp. lazy product images) load and grow a panel, so a
    // panel that fit at first-paint doesn't overflow once its media arrives (founder: "make this fit").
    // Blair (Claude 2026-07-29, perf): an image finishing can only change the height of ITS OWN panel,
    // so re-fit just that panel instead of re-fitting all twenty. With ~245 images on the homepage the
    // old global version meant every late image scheduled another whole-page measure pass.
    panels.forEach(function (p) {
      [].slice.call(p.querySelectorAll('img')).forEach(function (img) {
        if (!img.complete) img.addEventListener('load', function () {
          clearTimeout(p._blairFitT);
          p._blairFitT = setTimeout(function () { if (window.innerWidth <= 989 && isRendered(p)) fitList([p]); }, 90);
        }, { once: true });
      });
    });

    bindPanelVisibility();

    // The all-products screen keeps its native 2-column grid (founder wants a 2x6 / 2x4 square
    // grid there, not a single swipe row). Mark its panel so the single-row CSS skips it.
    var allProd = document.querySelector('.blair-panel [id$="__featured_collection_gpRk9c"]');
    if (allProd) {
      var app = allProd.closest('.blair-panel');
      if (app) {
        app.classList.add('blair-panel--grid');
        buildMarquee(app);   // two-row auto-scroll marquee of all the products
      }
    }

    // Founder ("make the marquee loop infinite"): the top category collection-list scrolls as a
    // continuous, seamless single-row marquee (like the product marquee) instead of a paginated
    // swipe slider. Items are cloned so translateX wraps at half-width with no jump; the original
    // slider-component is hidden (kept in the DOM as a graceful fallback).
    (function buildCollectionMarquee() {
      // Founder 2026-07-15 (blairtlv1): prefer the ORIGINAL paginated category slider (with its
      // dots pager + bottom-label cards, same as desktop) over the continuous auto-scroll marquee.
      // Disabled so the native slider-component stays visible on mobile instead of being cloned +
      // hidden — one consistent category style across desktop and mobile.
      return;
      // eslint-disable-next-line no-unreachable
      if (window.innerWidth > 989) return;
      var grid = document.querySelector('.blair-panel .collection-list');
      if (!grid || grid.dataset.blairMarquee) return;
      var items = [].slice.call(grid.children).filter(function (n) { return n.nodeType === 1; });
      if (items.length < 2) return;
      grid.dataset.blairMarquee = '1';
      var slider = grid.closest('slider-component') || grid;
      var wrap = document.createElement('div');
      wrap.className = 'blair-marquee blair-marquee--collections';
      var row = document.createElement('div');
      row.className = 'blair-marquee__row blair-marquee__row--slow';
      var track = document.createElement('div');
      track.className = 'blair-marquee__track';
      items.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
      items.forEach(function (it) { track.appendChild(it.cloneNode(true)); });  // duplicate for seamless loop
      row.appendChild(track);
      wrap.appendChild(row);
      slider.parentNode.insertBefore(wrap, slider);
      slider.style.display = 'none';
      driveMarquee(wrap);
    })();

    // Hero "There's more below" chevron: jump to the next swipe screen (native snap lands on it).
    var heroBtn = document.querySelector('.blair-hero__scroll');
    if (heroBtn && panels[1] && !heroBtn.dataset.blairDeckBound) {
      heroBtn.dataset.blairDeckBound = '1';
      heroBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var target = panels[1];
        if (!target) { window.scrollBy({ top: Math.round(window.innerHeight * 0.9), behavior: 'smooth' }); return; }
        if (window.innerWidth > 989) {
          // desktop is normal flow: scroll to the next section, parked just under the fixed header
          var header = document.querySelector('.blair-header-fixed') || document.querySelector('.header-wrapper');
          var hH = header ? header.getBoundingClientRect().height : 0;
          var top = target.getBoundingClientRect().top + window.scrollY - hH - 8;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
          return;
        }
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });   // mobile: native snap lands on it
      }, true);
    }

    // Marquee (announcement bar) is a normal-flow section, so on the swipe deck it scrolls away
    // after a moment while the fixed header stays. Pin it to follow the header so it always shows.
    (function pinMarquee() {
      var ann = document.querySelector('.announcement-bar');
      var annSec = ann && ann.closest('.shopify-section');
      var header = document.querySelector('.blair-header-fixed') || document.querySelector('.header-wrapper');
      if (!annSec || !header) return;
      // The bar's background is transparent by default, so once pinned it floats over the hero and the
      // marquee text reads as broken. Paint it solid from its own colour scheme (inline !important beats
      // Dawn's scheme rules) so it looks like a clean bar (founder: "fix the marquee").
      var scheme = ann.querySelector('[class*="color-scheme"]') || ann;
      var bgVar = getComputedStyle(scheme).getPropertyValue('--color-background').trim();
      var solidBg = bgVar ? 'rgb(' + bgVar + ')' : '';
      // Blair (blairtlv1 2026-07-16, perf): this runs on every scroll frame on mobile. It used to
      // rewrite position/left/right/top/zIndex + clear two background props EVERY frame even though
      // only `top` ever changes (and only between two values). Dirty-check so the constant styles are
      // written once per mode and `top` only when it actually changes — same rendered bar, far fewer
      // style mutations per scroll frame.
      var applied = { mode: null, top: null };
      function place() {
        if (window.innerWidth > 989) {
          if (applied.mode !== 'desktop') {
            annSec.style.position = ''; annSec.style.top = ''; annSec.style.zIndex = '';
            ann.style.removeProperty('background');
            ann.style.removeProperty('background-color');
            applied.mode = 'desktop'; applied.top = null;
          }
          return;
        }
        var hb = header.getBoundingClientRect();
        if (applied.mode !== 'mobile') {
          annSec.style.position = 'fixed';
          annSec.style.left = '0'; annSec.style.right = '0';
          annSec.style.zIndex = '6';
          applied.mode = 'mobile'; applied.top = null;
        }
        // Sit the bar directly BELOW the header, as its own strip.
        // This used to be `hb.bottom - annH`, which parked the marquee INSIDE the header's bottom
        // band: the text rendered as faint grey behind the logo, half-clipped by the header edge.
        // That is what "the marquee doesn't show" looked like, and why it was hidden on 2026-07-12.
        var top = Math.max(0, Math.round(hb.bottom));
        if (top !== applied.top) { annSec.style.top = top + 'px'; applied.top = top; }
        // Founder 2026-07-15 ("keep the marquee transparent, i liked it better"): the bar stays
        // TRANSPARENT in every scroll state — no solid scheme colour when scrolled. We just clear
        // any inline background so the CSS cascade wins (header-overlay's template-index transparent
        // !important). Earlier this painted a solid grey once scrolled-past-header to stop the pinned
        // bar reading as broken over content; the founder prefers the fully transparent look and
        // accepts the text floating over the hero/content. (solidBg is left computed but unused so
        // reverting to the two-state behaviour is a one-line change.)
        ann.style.removeProperty('background');
        ann.style.removeProperty('background-color');
      }
      place();
      window.addEventListener('resize', place);
      window.addEventListener('load', place);
      window.addEventListener('scroll', function () { if ('requestAnimationFrame' in window) requestAnimationFrame(place); else place(); }, { passive: true });
    })();

    // Newsletter screen: fill its empty space with the store's lifestyle image (reuse the footer
    // shot), keeping white space at the bottom for the floating chat/accessibility widgets (founder).
    // MOBILE ONLY (founder 2026-07-15: "on desktop remove the bottom image at the footer — gold ring
    // on a lady"). This fill exists to occupy the empty half of the newsletter SWIPE screen; on
    // desktop the whole deck is normal flow and all the newsletter styling lives under
    // @media (max-width:989px), so the injected image lands unstyled as a big half-empty photo by the
    // footer. Its deck CSS can't hide it on desktop (it's nested inside that mobile media block), so
    // the clean fix is to not create it on desktop at all — also saves loading a 900px image there.
    var nlSec = window.innerWidth <= 989 ? document.querySelector('.blair-panel [id$="__newsletter_Xq4hEj"]') : null;
    // Use a different, on-brand lifestyle image (a collection tile) rather than the footer photo.
    var srcImg = document.querySelector('.blair-panel [id$="__collection_list_PifXta"] img')
      || document.querySelector('.blair-panel [id*="slideshow"] img')
      || document.querySelector('.blair-panel--footer img');
    if (nlSec && srcImg && !document.querySelector('.blair-nl-image')) {
      var nlPanel = nlSec.closest('.blair-panel');
      var src = srcImg.getAttribute('src') || srcImg.currentSrc || '';
      var nlInner = nlPanel && nlPanel.querySelector('.blair-panel__inner');
      if (nlInner && src) {
        var box = document.createElement('div'); box.className = 'blair-nl-image';
        var img = document.createElement('img'); img.src = src; img.alt = ''; img.loading = 'eager';
        box.appendChild(img); nlInner.appendChild(box);
      }
    }

    // Search-open scroll-jump fix: when the search modal opens, keep the current swipe screen in
    // place (Dawn focuses the input, which scrolls the deck up). Lock scrollY across a few frames.
    var searchToggle = document.querySelector('summary.header__icon--search, .header__icon--search.modal__toggle');
    var searchDetails = searchToggle && searchToggle.closest ? searchToggle.closest('details') : null;
    if (searchDetails && !searchDetails.dataset.blairDeckBound) {
      searchDetails.dataset.blairDeckBound = '1';
      searchDetails.addEventListener('toggle', function () {
        if (!searchDetails.open || window.innerWidth > 989) return;
        var y = window.scrollY;
        var restore = function () { if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y); };
        if ('requestAnimationFrame' in window) requestAnimationFrame(restore);
        setTimeout(restore, 40); setTimeout(restore, 140); setTimeout(restore, 320);
      });
    }

    fit();
    return true;
  }

  // Build the all-products screen into a two-row auto-scroll marquee (row 0 slow, row 1 fast).
  // Cards are split across two rows, and each row's items are cloned once so translateX(-50%)
  // loops seamlessly. Original grid is hidden; the collection's "View all" link stays.
  function buildMarquee(panel) {
    if (!panel || panel.dataset.marquee) return;
    if (window.innerWidth > 989) return;   // mobile-only; desktop keeps the normal grid
    var grid = panel.querySelector('.product-grid, ul.grid');
    if (!grid) return;
    var items = [].slice.call(grid.children).filter(function (n) { return n.nodeType === 1; });
    if (items.length < 4) return;
    panel.dataset.marquee = '1';
    panel.classList.add('blair-has-marquee');   // CSS hides the grid (mobile only) — no inline style
    var wrap = document.createElement('div');
    wrap.className = 'blair-marquee';
    var rows = [[], []];
    var tracks = [];
    items.forEach(function (it, i) { rows[i % 2].push(it); });
    // (re)fill a track from its row: the originals, then one clone of each for the seamless -50% wrap.
    function renderTrack(track, rowItems) {
      track.textContent = '';
      rowItems.forEach(function (it) { track.appendChild(it); });
      rowItems.forEach(function (it) { track.appendChild(it.cloneNode(true)); });
    }
    ['slow', 'fast'].forEach(function (speed, ri) {
      var row = document.createElement('div');
      row.className = 'blair-marquee__row blair-marquee__row--' + speed;
      var track = document.createElement('div');
      track.className = 'blair-marquee__track';
      renderTrack(track, rows[ri]);
      row.appendChild(track);
      wrap.appendChild(row);
      tracks.push(track);
    });
    grid.parentNode.insertBefore(wrap, grid);
    driveMarquee(wrap);
    // A Shopify section renders at most 50 products; the founder wants the WHOLE store shown here, so
    // lazily fetch the rest of the collection and fold it into the two rows after the first 50 paint.
    loadAllProducts(panel, items, rows, tracks, renderTrack);
  }

  function handleFromHref(a) {
    var h = a && a.getAttribute('href');
    var m = h && h.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Fetch the collection's full product list (JSON) and append every product not already in the first
  // 50 as a marquee card, then re-render both tracks and re-measure. Images stay lazy; drag/loop keep
  // working because driveMarquee re-measures on the resize event we fire.
  function loadAllProducts(panel, initialItems, rows, tracks, renderTrack) {
    var hook = panel.querySelector('[data-blair-collection-url]');
    var base = hook && hook.getAttribute('data-blair-collection-url');
    if (!base || !initialItems.length) return;
    var template = initialItems[0];
    var seen = {};
    initialItems.forEach(function (it) {
      var h = handleFromHref(it.querySelector('a[href*="/products/"]'));
      if (h) seen[h] = 1;
    });
    // Smart: don't pull the whole catalogue on every homepage load — only when the all-products panel
    // is within ~two screens of the viewport. Falls back to an immediate fetch if IO is unavailable.
    var fired = false;
    function run() { if (fired) return; fired = true; doFetch(); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) { io.disconnect(); run(); }
      }, { rootMargin: '200% 0px' });
      io.observe(panel);
    } else { run(); }

    function doFetch() {
    fetch(base + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.products) return;
        var added = 0, ri = rows[0].length <= rows[1].length ? 0 : 1;
        data.products.forEach(function (p) {
          if (!p || !p.handle || seen[p.handle]) return;   // skip anything already in the first 50
          seen[p.handle] = 1;
          var card = makeProductCard(template, p);
          if (!card) return;
          rows[ri].push(card);
          ri = ri ? 0 : 1;                                  // alternate the two rows
          added++;
        });
        if (!added) return;
        renderTrack(tracks[0], rows[0]);
        renderTrack(tracks[1], rows[1]);
        window.dispatchEvent(new Event('resize'));           // driveMarquee re-measures the new width
      })
      .catch(function () { /* network hiccup: the first 50 already show, so degrade silently */ });
    }
  }

  // Clone a rendered card as a template and swap in a fetched product's link, image, title and price,
  // so the injected cards are structurally identical to the server-rendered ones (deck CSS applies).
  function makeProductCard(template, p) {
    if (!template) return null;
    // the template's rendered title, used as a needle when the class lookup fails
    var th = template.querySelector('.card__heading a') || template.querySelector('.card__heading');
    var templateTitle = th ? (th.textContent || '').trim() : '';
    var el = template.cloneNode(true);
    el.removeAttribute('id'); el.removeAttribute('style');
    [].slice.call(el.querySelectorAll('link,script,style,noscript')).forEach(function (n) { n.remove(); });
    var title = (p.title || '').trim();
    var url = '/products/' + p.handle;
    [].slice.call(el.querySelectorAll('a[href]')).forEach(function (a) { a.setAttribute('href', url); });

    // Blair (blairtlv4 2026-07-28): EVERY injected card was showing the TEMPLATE's product
    // name — the founder saw one title repeated across a necklace, a ring and a bracelet while
    // the prices were all correct. Cause: this looked for .card__heading only, and when that
    // lookup missed, the line was skipped silently and the clone kept the template's title.
    // A card with the wrong name is worse than a card that is not shown, so:
    //   1. try several selectors,
    //   2. fall back to finding whatever node actually holds the template's own title text,
    //   3. if the title still cannot be set, DROP the card instead of publishing a wrong name.
    var t = el.querySelector('.card__heading a') || el.querySelector('.card__heading') ||
            el.querySelector('.card-information__text') || el.querySelector('.card__inner + * a') ||
            el.querySelector('h1,h2,h3,h4,h5,h6');
    if (!t && templateTitle) {
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_ELEMENT, null);
      var node;
      while ((node = walker.nextNode())) {
        if (node.children.length === 0 && (node.textContent || '').trim() === templateTitle) { t = node; break; }
      }
    }
    if (!t || !title) return null;
    t.textContent = title;
    var img = el.querySelector('img');
    var src = p.images && p.images[0] && p.images[0].src;
    if (img && src) {
      var sep = src.indexOf('?') > -1 ? '&' : '?';
      img.setAttribute('src', src + sep + 'width=400');
      img.setAttribute('srcset', src + sep + 'width=360 360w, ' + src + sep + 'width=540 540w, ' + src + sep + 'width=720 720w');
      img.setAttribute('sizes', '30vh');
      img.setAttribute('loading', 'lazy');
      img.setAttribute('alt', title);
      img.removeAttribute('width'); img.removeAttribute('height');
    } else if (img && !src) {
      return null;                                  // no image -> skip rather than show an empty tile
    }
    var price = el.querySelector('.price');
    var val = p.variants && p.variants[0] && p.variants[0].price;
    if (price && val != null) {
      price.className = 'price';
      price.innerHTML = '<div class="price__container"><div class="price__regular">' +
        '<span class="price-item price-item--regular">₪' + val + '</span></div></div>';
    }
    return el;
  }

  // Blair (Claude 2026-07-29, perf): TOP-UP.
  //
  // Every featured collection on the homepage used to render 50 products server-side. Five of them, so
  // the homepage shipped ~123 product cards inside 1.2MB of HTML and 8,400 DOM nodes, and every single
  // style recalc had to walk all of it. That is what made the mobile homepage spend 43 of 75 seconds in
  // Style & Layout. But a shopper only ever sees two or three cards of a row at a time — the other 47
  // exist purely to be swiped to later.
  //
  // So the sections now render a small first batch (see templates/index.json) and this fills each row
  // back up to the full count from the collection's own JSON, but only once that row is within ~two
  // screens of the viewport. Nothing is lost: swipe far enough and the products are there, because the
  // fetch fires long before the row can be reached. Cards are built by makeProductCard, which clones a
  // real server-rendered card, so injected cards are structurally identical and every deck CSS rule,
  // lazy-image attribute and link still applies.
  //
  // The all-products marquee panel is deliberately EXCLUDED: it has its own richer loader
  // (loadAllProducts) which folds the whole catalogue into two alternating rows.
  var TOPUP_TO = 50;                                   // what the sections used to render server-side
  function topUpCollections() {
    [].slice.call(document.querySelectorAll('[data-blair-collection-url]')).forEach(function (host) {
      if (host.dataset.blairToppedUp) return;
      var grid = host.querySelector('.product-grid, ul.grid');
      if (!grid) return;
      if (host.closest && host.closest('.blair-has-marquee')) return;      // marquee owns its own loader
      if (grid.closest && grid.closest('.blair-has-marquee')) return;
      var items = [].slice.call(grid.children).filter(function (n) { return n.nodeType === 1; });
      if (!items.length) return;
      var total = parseInt(host.getAttribute('data-blair-collection-count'), 10) || 0;
      var want = Math.min(TOPUP_TO, total || TOPUP_TO);
      if (items.length >= want) return;                                    // small collection, nothing to add
      host.dataset.blairToppedUp = '1';

      var base = host.getAttribute('data-blair-collection-url');
      var template = items[0];
      var seen = {};
      items.forEach(function (it) {
        var h = handleFromHref(it.querySelector('a[href*="/products/"]'));
        if (h) seen[h] = 1;
      });

      var fired = false;
      function run() {
        if (fired) return;
        fired = true;
        fetch(base + '/products.json?limit=' + want, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            if (!data || !data.products) return;
            var frag = document.createDocumentFragment(), added = 0;
            data.products.forEach(function (p) {
              if (added + items.length >= want) return;
              if (!p || !p.handle || seen[p.handle]) return;
              seen[p.handle] = 1;
              var card = makeProductCard(template, p);
              if (!card) return;
              frag.appendChild(card);
              added++;
            });
            if (!added) return;
            grid.appendChild(frag);                                        // one insert, one layout
            var panel = host.closest ? host.closest('.blair-panel') : null; // row grew → re-fit just it
            if (panel && window.innerWidth <= 989 && isRendered(panel)) fitList([panel]);
          })
          .catch(function () { /* network hiccup: the first batch already shows, degrade silently */ });
      }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); run(); }
        }, { rootMargin: '200% 0px' });
        io.observe(host);
      } else { run(); }
    });
  }

  // Continuous, smooth (no jumps) marquee driven by transform:translateX on a rAF loop. transform is
  // GPU-composited so per-frame updates are cheap (scrollLeft was the lag). The user can drag it by
  // hand — the drag delta is added to the same `pos`, so the auto-drift resumes from the dragged spot
  // with no jump — and tapping a product still navigates (a real drag suppresses the click). Loops
  // seamlessly because each row's items are cloned once (wrap at half the track width).
  function driveMarquee(wrap) {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Blair (blairtlv1 2026-07-16, perf): skip rendering the off-screen marquee cards. This
    // all-products marquee can hold the WHOLE store (loadAllProducts pulls up to ~250 products, and
    // each row is doubled for the seamless -50% loop) → up to ~1000 image cards live in ONE track that
    // is transformed every frame. Compositing + rastering all of them is what makes low-end phones
    // stutter. content-visibility:auto lets the browser skip layout/paint/raster for cards that aren't
    // near the viewport, so only the handful on screen cost anything — visually identical while it
    // scrolls, and lazy images off-screen never even load. contain-intrinsic-size reserves each card's
    // EXACT measured box (via a var) so the loop math (half = scrollWidth/2) and the row height never
    // shift when a card is skipped. Measured with CV off so the reading is the true rendered box; the
    // card box is fixed by CSS (a square + one-line title/price), so only a viewport resize changes it.
    function tuneCV() {
      var sample = wrap.querySelector('.blair-marquee__track > *');
      if (!sample) return;
      wrap.classList.remove('blair-mq-cv');
      var r = sample.getBoundingClientRect();
      if (r.width > 20 && r.height > 20) {
        wrap.style.setProperty('--blair-mq-cw', Math.round(r.width) + 'px');
        wrap.style.setProperty('--blair-mq-ch', Math.round(r.height) + 'px');
        wrap.classList.add('blair-mq-cv');
      }
    }
    tuneCV();
    var cvT;
    window.addEventListener('resize', function () { clearTimeout(cvT); cvT = setTimeout(tuneCV, 200); });

    [].slice.call(wrap.querySelectorAll('.blair-marquee__row')).forEach(function (row) {
      var track = row.querySelector('.blair-marquee__track');
      if (!track) return;
      var speed = row.classList.contains('blair-marquee__row--fast') ? 0.55 : 0.32; // px per 16.7ms
      var half = 0;
      function measure() { half = track.scrollWidth / 2; }
      measure();
      window.addEventListener('resize', measure);
      [].slice.call(track.querySelectorAll('img')).forEach(function (img) {
        img.decoding = 'async';                       // decode off the main thread — smoother reveal on weak CPUs
        if (!img.complete) img.addEventListener('load', measure, { once: true });
      });
      // drift = auto-scroll direction (-1 = the default leftward drift). Blair (blairtlv1 2026-07-16):
      // if the user drags the row the other way, adopt THAT direction instead of snapping back to the
      // original one (founder: "don't fight with him").
      var pos = 0, dragging = false, startX = 0, startPos = 0, moved = 0, last = null, drift = -1;
      row.addEventListener('touchstart', function (e) { dragging = true; startX = e.touches[0].clientX; startPos = pos; moved = 0; }, { passive: true });
      row.addEventListener('touchmove', function (e) { if (!dragging) return; var dx = e.touches[0].clientX - startX; if (Math.abs(dx) > moved) moved = Math.abs(dx); pos = startPos + dx; }, { passive: true });
      ['touchend', 'touchcancel'].forEach(function (ev) { row.addEventListener(ev, function () { dragging = false; if (moved > 8) drift = (pos - startPos > 0) ? 1 : -1; }, { passive: true }); });
      // a real drag must not also trigger the tapped product's link
      track.addEventListener('click', function (e) { if (moved > 8) { e.preventDefault(); e.stopPropagation(); } }, true);
      var rafId = null;
      function frame(t) {
        if (last === null) last = t;
        var dt = t - last; last = t;
        if (dt > 100) dt = 16.7;                       // was backgrounded: don't jump
        if (!dragging && !reduce && half > 10) pos += drift * speed * (dt / 16.7);
        if (half > 10) { while (pos <= -half) pos += half; while (pos > 0) pos -= half; } // seamless wrap both ways
        track.style.transform = 'translateX(' + pos + 'px)';
        rafId = requestAnimationFrame(frame);
      }
      // Blair (blairtlv1 2026-07-16, perf): only animate while the row is on-screen. This marquee
      // sits ~6 screens down, so it used to burn a rAF + keep a GPU layer alive every frame for the
      // whole session even when unseen. Pause the loop and drop will-change when off-screen; under
      // reduced-motion don't run it at all (position is static anyway). Visually identical on-screen.
      function start() { if (rafId === null) { last = null; track.style.willChange = 'transform'; rafId = requestAnimationFrame(frame); } }
      function stop() { if (rafId !== null) { cancelAnimationFrame(rafId); rafId = null; } track.style.willChange = 'auto'; }
      if (reduce) {
        track.style.willChange = 'auto';
      } else if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { rootMargin: '150px 0px' }).observe(row);
      } else {
        start();
      }
    });
  }

  // TikTok-style paging is done with NATIVE CSS scroll-snap (mandatory + scroll-snap-stop: always,
  // see the snippet CSS). No custom gesture pager — native scroll is reliable and never locks up.

  // The CSS flex layout does the real work of making the components fill one screen. This is only
  // a SHRINK-ONLY safety net: if a panel's content still overflows (e.g. a very tall section on a
  // short phone), scale it down just enough so nothing is clipped. Never enlarges (flex fills).
  // Components are sized by HEIGHT (lvh) in CSS so a panel fits the screen on any phone (founder).
  // This is only a final safety-net: if a panel still overflows a little, shrink it just enough.
  // Blair (Claude 2026-07-29, perf): a panel that content-visibility has SKIPPED cannot be measured —
  // its subtree is not laid out, so scrollHeight reads as the reserved intrinsic size, not the real
  // content height. Fitting it then would compute a meaningless zoom and, worse, leave a genuinely
  // overflowing panel unshrunk (the panel is overflow:hidden, so that shows up as CONTENT CUT OFF).
  // So: only ever fit panels the browser is actually rendering, and fit each one the moment it starts
  // being rendered (see the contentvisibilityautostatechange listener below). checkVisibility with
  // contentVisibilityAuto is the supported way to ask; where it is missing (older browsers, which also
  // do not support content-visibility and therefore never skip anything) treat every panel as fittable,
  // which is exactly the old behaviour.
  // The skipped state comes from the browser's own contentvisibilityautostatechange event, recorded on
  // the element (see bindPanelVisibility). Do NOT use checkVisibility({contentVisibilityAuto:true}) for
  // this: it was tried first and reports "not skipped" for panels that the event says ARE skipped, so
  // fit() measured all twelve, and measuring a skipped subtree is layout-inducing — it forced every
  // panel back into full layout and cancelled out the whole optimisation. Panels start out rendered and
  // the event only fires on a CHANGE, so an untouched panel correctly reads as rendered.
  function isRendered(p) {
    return !p._blairSkipped;
  }

  // Shrink-to-fit a specific set of panels. Batched: clear all zoom (writes) → read all heights (one
  // reflow) → apply all zoom (writes), instead of write/read/write per panel (~10 forced reflows).
  function fitList(list) {
    var items = [];
    list.forEach(function (p) {
      var inner = p.querySelector('.blair-panel__inner');
      if (!inner) return;
      inner.style.zoom = '';
      if (inner.querySelector('.blair-hero')) return;   // hero owns its own full-bleed layout
      items.push({ p: p, inner: inner });
    });
    if (!items.length) return;
    // Blair (blairtlv2 2026-07-21): subtract the panel's bottom padding. That padding is the URL-bar
    // spacer (calc(100lvh - 100svh), see the snippet CSS) and clientHeight INCLUDES padding, so
    // measuring it raw over-reports the usable height by the spacer and a panel that really does
    // overflow the bar-showing viewport would never get shrunk. The content box is what must fit.
    items.forEach(function (it) {
      var padB = parseFloat(getComputedStyle(it.p).paddingBottom) || 0;
      it.panelH = it.p.clientHeight - padB;
      it.contentH = it.inner.scrollHeight;
    });
    items.forEach(function (it) {
      if (it.panelH && it.contentH > it.panelH + 4) {
        var floor = it.p.classList.contains('blair-panel--footer') ? 0.4 : 0.55;
        it.inner.style.zoom = Math.max(floor, it.panelH / it.contentH);
      }
    });
  }

  function fit() {
    if (window.innerWidth > 989) {                      // desktop: no deck, clear any leftover zoom
      panels.forEach(function (p) {
        var inner = p.querySelector('.blair-panel__inner');
        if (inner) inner.style.zoom = '';
      });
      return;
    }
    fitList(panels.filter(isRendered));
  }

  // Fit a panel the moment the browser starts rendering it (it fires while the panel is still just
  // OUTSIDE the viewport, so the zoom is already applied by the time it is scrolled to — no visible
  // resize). This is what replaces fitting all twenty panels on a timer.
  function bindPanelVisibility() {
    if (!('oncontentvisibilityautostatechange' in HTMLElement.prototype)) return;
    panels.forEach(function (p) {
      if (p._blairCvBound) return;                     // build() can re-run and make fresh panels
      p._blairCvBound = true;
      p.addEventListener('contentvisibilityautostatechange', function (e) {
        p._blairSkipped = e.skipped;                   // authoritative source for isRendered()
        if (!e.skipped && window.innerWidth <= 989) fitList([p]);
      });
    });
  }
  function schedule() { if ('requestAnimationFrame' in window) requestAnimationFrame(fit); else fit(); }

  // Run as early as possible, and again at the reliable lifecycle points.
  build();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', build);
  // Blair (Claude 2026-07-29, perf): the timer cascade used to be [300, 1000, 2000, 3500, 5000] — five
  // whole-page measure passes, each one a forced layout over every panel, all landing while the CPU is
  // still busy decoding images. That cascade existed to catch panels whose content grew late. It is no
  // longer the mechanism that does that: each panel is now re-fitted when its own images finish and
  // again when the browser starts rendering it (contentvisibilityautostatechange), which is both more
  // accurate and roughly free. Two settling passes are kept for the panels that are rendered from the
  // start (nothing else would re-trigger those).
  window.addEventListener('load', function () {
    build();
    topUpCollections();   // after build(), so the marquee panel is already flagged and gets excluded
    schedule();
    [500, 2000].forEach(function (ms) { setTimeout(fit, ms); });
  });
  // fonts swapping in reflows the text and can grow a panel after the initial fit — re-fit then.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { setTimeout(fit, 60); });

  // If a storefront app re-renders #MainContent after load, rebuild the deck.
  try {
    var mo = new MutationObserver(function () {
      if (!doc.querySelector('.blair-panel') && sectionEl('blair_hero_main')) build();
    });
    var target = document.getElementById('MainContent');
    if (target) mo.observe(target, { childList: true });
  } catch (e) {}

  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 150); });
})();
